export default {
  subscription: {
    en: 'Subscription',
  },
  oneTimePurchase: {
    en: 'One-time purchase',
  },
  oneTimeShipment: {
    en: 'One-time',
  },
  fullSize: {
    en: 'Full size',
  },
}
